// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import ValidationAndVsrErrorMessages from '../validation-and-vsr-error-messages';
import {getFieldClassName} from '../../services/claim-shared-helper';

function handleChange() {

    this.onChange(!this.isSelected);

}

const LabeledCheckbox = props => {

    const modifiedClassName = getFieldClassName(props.className, true, props.highlightClass);

    return (

        <LabeledFormInput
            className={modifiedClassName}
            label={props.label}
        >
            {props.isEditable ?
                <div>
                    <Checkbox
                        id={props.id}
                        onChange={props::handleChange}
                        selected={props.isSelected}
                    >
                        {''}
                    </Checkbox>
                    <ValidationAndVsrErrorMessages
                        errorMessage={''}
                        isValid={true}
                        vsrMessage={props.vsrMessage}
                    />
                </div> :
                <FormattedMessage id={props.translationId}/>
            }
        </LabeledFormInput>

    );

};

LabeledCheckbox.displayName = 'LabeledCheckbox';
LabeledCheckbox.propTypes = {
    className: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    id: PropTypes.string.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    translationId: PropTypes.string.isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledCheckbox;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-checkbox-with-error.js